import React from 'react';
import { Box } from '@chakra-ui/react';
import MobileMenu from '../mobileComponents/MobileMenu';

export default function InvestorsContent() {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="space-between" h="100%">
      <Box>InvestorsContent</Box>
      <Box display={['block', 'block', 'none']} width="94%" margin="0 auto">
        <MobileMenu />
      </Box>
    </Box>
  );
}
